module.exports = __webpack_public_path__ + "img/img-icon.f15927f1.png";